/**
 * Admin-only links. The API base URL still comes from `@wlb/shared/config`;
 * this is only the operator's shortcut back to the member site, which the
 * shared config has no reason to know about.
 *
 * An unset value hides the link rather than guessing a host.
 */
const raw = import.meta.env.VITE_WEB_APP_URL;

export const MEMBER_SITE_URL: string =
  typeof raw === 'string' && raw.trim().length > 0 ? raw.trim() : '';
